export default "__VITE_ASSET__55366f56__"